import { Tooltip } from "@exact-magic/ui";
import { cn } from "./utils";

export interface IndicatorProps {
  status: "online" | "offline";
  className?: string;
  children: React.ReactNode;
  tooltip?: string;
}

export const Indicator = ({
  status,
  className,
  children,
  tooltip,
}: IndicatorProps) => {
  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <div className="relative">
          {children}
          <div
            className={cn(
              "absolute bottom-0 right-0 size-3 rounded-full",
              {
                "bg-green-500": status === "online",
                "bg-red-400": status === "offline",
              },
              className
            )}
          />
        </div>
      </Tooltip.Trigger>
      {tooltip && (
        <Tooltip.Content side="bottom" placeholder={"tooltip"}>
          {tooltip}
        </Tooltip.Content>
      )}
    </Tooltip>
  );
};
